module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        _vm.boxUpdateConfig({
          item: 'advanced',
          key: 'view_mode',
          value: 'automatic'
        });
        _vm.sidebarChangePanel('themes')
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pull-right"
  }, [_c('div', {
    staticClass: "box-title"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.auto')))]), _vm._v(" "), _c('span', {
    staticClass: "box-text"
  }, [_vm._v(_vm._s(_vm.$t('edit.sidebar.at_some_point')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-image"
  }, [_c('img', {
    attrs: {
      "src": require("../../../../assets/img/box-auto.svg"),
      "alt": ""
    }
  })])
}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-467aeda5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/sidebar/viewmode/Automatic.vue
 ** module id = 814
 ** module chunks = 1
 **/